import { render, staticRenderFns } from "./FpSpecsFilter.vue?vue&type=template&id=bfcfd4e2&scoped=true"
import script from "./FpSpecsFilter.vue?vue&type=script&lang=js"
export * from "./FpSpecsFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfcfd4e2",
  null
  
)

export default component.exports